import React from 'react';
import { useTranslation } from 'react-i18next';

import scss from './UserTable.module.scss';

const DeleteUserLabel = ({ name }) => {
  const { t } = useTranslation('userManagement');

  return (
    <span>
      {t('doYouReallyWantToDelete')}: <span className={scss.stressedName}>{name}</span>?
    </span>
  );
};

export default DeleteUserLabel;
